import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RETRY_MESSAGE, show_popup, TITLE_ERROR } from '@shared/utility/popup-error';
import { EMPTY, Observable } from 'rxjs';
import { NextFlow } from '../model/enums/next-flow';
import { Navigable } from '../model/navigable';
import { Redirectable } from '../model/redirectable';
import { MessageService } from './message.service';

import { ROUTES_CONSTANTS } from '@shared/configs';

@Injectable({
  providedIn: 'root',
})
export class RedirectionService {
  constructor(private router: Router, private messageService: MessageService) {}

  nextFlow(response: Redirectable & Navigable): Observable<boolean> {
    if ((response as unknown as { type: string })?.type === NextFlow.DocumentIssueOfDateDoesNotMatch) {
      this.router.navigate([ROUTES_CONSTANTS.DOCUMENT_ISSUE]);
      return EMPTY;
    }

    return new Observable((subscriber) => {
      if ('nextFlow' in response) {
        switch (response.nextFlow) {
          case NextFlow.DisbursementAccountSelection:
          case NextFlow.Efecty:
          case NextFlow.DispersionMethodSelection:
            this.customRedirect();
            break;
          case NextFlow.CounterOffer:
            if ('counterofferResponseDto' in response) {
              this.messageService.publish('counter-offer', response['counterofferResponseDto']);
            }
            this.router.navigate(['account/counterOffer']);
            break;
          case NextFlow.References:
            this.router.navigate([ROUTES_CONSTANTS.DECISION_MODEL]);
            break;
          case NextFlow.DocumentIssueOfDateDoesNotMatch:
            this.router.navigate([ROUTES_CONSTANTS.DOCUMENT_ISSUE]);
            break;
          case NextFlow.Redirection:
            if (response.urlRedirect) {
              this.router.navigate([response.urlRedirect]);
            } else {
              console.warn('Unknown redirection');
              subscriber.next(false);
            }
            break;
          case NextFlow.OnBoardingFlow:
            this.router.navigate([response.urlRedirect]);
            break;
          default:
            console.warn('Unknown redirection');
            subscriber.next(false);
            this.navigateTo(response.urlRedirect);
            break;
        }
      } else {
        subscriber.next(false);
      }
    });
  }

  public customRedirect(): void {
    this.router.navigate([ROUTES_CONSTANTS.DECISION_MODEL]);
  }

  navigateTo(url: string): void {
    if (this.isValidUrl(url)) {
      window.location.href = url;
    } else {
      this.router.navigate([url]);
    }
  }

  isValidUrl(url: string) {
    try {
      new URL(url);
    } catch (_) {
      return false;
    }

    return true;
  }

  showErrorAndRedirect(reason: string, url?: string): void {
    show_popup(TITLE_ERROR, RETRY_MESSAGE.replace('{reason}', reason));
    if (url) {
      this.router.navigate([url]);
    }
  }
}
